import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

type LoadingAreaProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {}

function LoadingArea({ className, ...restProps }: LoadingAreaProps) {
  return (
    <div className={'flex justify-center items-center w-full h-8 ' + className} {...restProps}>
      <LoadingOutlined className={'text-lg'} />
    </div>
  );
}

export default LoadingArea;